export type UserMode = 'admin' | 'enduser';

export interface NavItem {
  href: string;
  label: string;
  adminOnly: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { href: '/dashboard', label: 'Inicio', adminOnly: false },
  { href: '/generate', label: 'Generar', adminOnly: true },
  { href: '/settings/entities', label: 'Estructura', adminOnly: true },
  { href: '/settings/mcp', label: 'MCP', adminOnly: true },
];

export const ADMIN_ROUTES = ['/settings', '/generate'];

export function getVisibleNavItems(mode: UserMode): NavItem[] {
  return NAV_ITEMS.filter((item) => !item.adminOnly || mode === 'admin');
}

export function isAdminRoute(pathname: string): boolean {
  return ADMIN_ROUTES.some((route) => pathname.startsWith(route));
}

export function isValidUserMode(value: string | null): value is UserMode {
  return value === 'admin' || value === 'enduser';
}
